/*
 * -----------------------------------------------------------------------
 *  <copyright file="audit-log/type-areas.ts" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import { AuditApplicationArea, AuditDataType } from 'types/graphql-global-types';

const TypeAreas = [
    {
        areas: [AuditApplicationArea.RISK_ASSESSMENT],
        type: AuditDataType.CRITICAL_VARIABLE,
        field: 'CriticalVariable',
    },
    {
        areas: [AuditApplicationArea.RISK_ASSESSMENT],
        type: AuditDataType.RISKS,
        field: 'Risks',
    },
    {
        areas: [AuditApplicationArea.RISK_ASSESSMENT],
        type: AuditDataType.STUDY_CONTROL,
        field: 'StudyControl',
    },
    {
        areas: [AuditApplicationArea.RISK_ASSESSMENT, AuditApplicationArea.ADMIN],
        type: AuditDataType.LIBRARY_CONTROL,
        field: 'LibraryControl',
    },
    {
        areas: [AuditApplicationArea.RISK_ASSESSMENT, AuditApplicationArea.ADMIN],
        type: AuditDataType.LIBRARY_RISK,
        field: 'LibraryRisk',
    },
    {
        areas: [AuditApplicationArea.RISK_ASSESSMENT],
        type: AuditDataType.ISMP,
        field: 'ISMP',
    },
    {
        areas: [AuditApplicationArea.RISK_ASSESSMENT],
        type: AuditDataType.RISK_ACTION,
        field: 'RiskAction',
    },
    {
        areas: [AuditApplicationArea.RISK_ASSESSMENT],
        type: AuditDataType.RISK_EVALUATION,
        field: 'RiskEvaluation',
    },
    {
        areas: [AuditApplicationArea.RISK_ASSESSMENT],
        type: AuditDataType.RISK_OBSERVATION,
        field: 'RiskObservation',
    },
    {
        areas: [AuditApplicationArea.RISK_ASSESSMENT, AuditApplicationArea.ADMIN],
        type: AuditDataType.RISK_EVALUATION_MODEL,
        field: 'RiskEvaluationModel',
    },
    {
        areas: [AuditApplicationArea.RISK_ASSESSMENT],
        type: AuditDataType.FUNCTIONAL_DATA_REVIEW,
        field: 'FunctionalDataReview',
    },
    {
        areas: [AuditApplicationArea.RISK_ASSESSMENT],
        type: AuditDataType.LIBRARY_FUNCTIONAL_DATA_REVIEW,
        field: 'LibraryFunctionalDataReview',
    },
    {
        areas: [AuditApplicationArea.REPORT],
        type: AuditDataType.PBI_RISK_REVIEW,
        field: 'PBIRiskReview',
    },
    {
        areas: [AuditApplicationArea.REPORT],
        type: AuditDataType.PBI_CUSTOM_REPORT_TEMPLATE,
        field: 'PBICustomReportTemplate',
    },
    {
        areas: [AuditApplicationArea.REPORT],
        type: AuditDataType.PBIRAM_REPORT_SIGNATORY,
        field: 'PBIRAMReportSignatory',
    },
    {
        areas: [AuditApplicationArea.REPORT],
        type: AuditDataType.PBIOPRA_REPORT_TEMPLATE,
        field: 'PBIOPRAReportTemplate',
    },
    {
        areas: [AuditApplicationArea.REPORT],
        type: AuditDataType.PBI_RISK_REVIEW_ATTENDEE,
        field: 'PBIRiskReviewAttendee',
    },
    {
        areas: [AuditApplicationArea.ADMIN],
        type: AuditDataType.NAMED_ITEM,
        field: 'NamedItem',
    },
    {
        areas: [AuditApplicationArea.ADMIN],
        type: AuditDataType.ORGANISATION,
        field: 'Organisation',
    },
    {
        areas: [AuditApplicationArea.ADMIN],
        type: AuditDataType.ORGANISATION_PRODUCT,
        field: 'OrganisationProduct',
    },
    {
        areas: [AuditApplicationArea.ADMIN],
        type: AuditDataType.ORGANISATION_INDICATION,
        field: 'OrganisationIndication',
    },
    {
        areas: [AuditApplicationArea.ADMIN],
        type: AuditDataType.ORGANISATION_PROGRAM,
        field: 'OrganisationProgram',
    },
    {
        areas: [AuditApplicationArea.ADMIN],
        type: AuditDataType.ORGANISATION_MEMBER,
        field: 'OrganisationMember',
    },
    {
        areas: [AuditApplicationArea.ADMIN],
        type: AuditDataType.ORGANISATION_ROLE,
        field: 'OrganisationRole',
    },
    {
        areas: [AuditApplicationArea.ADMIN],
        type: AuditDataType.PLUGIN,
        field: 'Plugin',
    },
    {
        areas: [AuditApplicationArea.ADMIN],
        type: AuditDataType.USERS,
        field: 'Users',
    },
    {
        areas: [AuditApplicationArea.ADMIN],
        type: AuditDataType.PANEL,
        field: 'Panel',
    },
    {
        areas: [AuditApplicationArea.ADMIN],
        type: AuditDataType.DATA_REVIEW_TABLE,
        field: 'DataReviewTable',
    },
    {
        areas: [AuditApplicationArea.ADMIN],
        type: AuditDataType.DASHBOARD,
        field: 'Dashboard',
    },
    {
        areas: [AuditApplicationArea.ADMIN],
        type: AuditDataType.EXTRA_DATA_FIELD,
        field: 'ExtraDataField',
    },
    {
        areas: [AuditApplicationArea.CENTRAL_MONITORING],
        type: AuditDataType.CENTRAL_MONITORING_OBSERVATION,
        field: 'CentralMonitoringObservation',
    },
    {
        areas: [AuditApplicationArea.CENTRAL_MONITORING],
        type: AuditDataType.CENTRAL_MONITORING_OBSERVATION_ACTION,
        field: 'CentralMonitoringObservationAction',
    },
    {
        areas: [AuditApplicationArea.ADMIN, AuditApplicationArea.CENTRAL_MONITORING],
        type: AuditDataType.STUDY,
        field: 'Study',
    },
    {
        areas: [AuditApplicationArea.ADMIN, AuditApplicationArea.CENTRAL_MONITORING],
        type: AuditDataType.STUDY_COHORT,
        field: 'StudyCohort',
    },
    {
        areas: [AuditApplicationArea.ADMIN, AuditApplicationArea.CENTRAL_MONITORING],
        type: AuditDataType.DATA_SET,
        field: 'DataSet',
    },
    {
        areas: [AuditApplicationArea.ADMIN, AuditApplicationArea.CENTRAL_MONITORING],
        type: AuditDataType.SITE_REVIEW,
        field: 'SiteReview',
    },
    {
        areas: [AuditApplicationArea.ADMIN, AuditApplicationArea.CENTRAL_MONITORING],
        type: AuditDataType.KRI_REVIEW,
        field: 'KriReview',
    },
    {
        areas: [AuditApplicationArea.RISK_ASSESSMENT, AuditApplicationArea.CENTRAL_MONITORING],
        type: AuditDataType.REPORT,
        field: 'Report',
    },
    {
        areas: [AuditApplicationArea.RISK_ASSESSMENT, AuditApplicationArea.CENTRAL_MONITORING],
        type: AuditDataType.REPORT_SIGNATORY,
        field: 'ReportSignatory',
    },
    {
        areas: [AuditApplicationArea.ADMIN, AuditApplicationArea.CENTRAL_MONITORING],
        type: AuditDataType.DATA_SET_REVIEW,
        field: 'DataSetReview',
    },
    {
        areas: [AuditApplicationArea.ADMIN, AuditApplicationArea.CENTRAL_MONITORING],
        type: AuditDataType.STUDY_CRF,
        field: 'StudyCrf',
    },
    {
        areas: [AuditApplicationArea.ADMIN, AuditApplicationArea.CENTRAL_MONITORING],
        type: AuditDataType.STUDY_MEMBER,
        field: 'StudyMember',
    },
    {
        areas: [AuditApplicationArea.ADMIN, AuditApplicationArea.CENTRAL_MONITORING],
        type: AuditDataType.STUDY_SUBJECT_VISIT_SCHEDULE_TEMPLATE,
        field: 'StudySubjectVisitScheduleTemplate',
    },
    {
        areas: [AuditApplicationArea.ADMIN, AuditApplicationArea.CENTRAL_MONITORING],
        type: AuditDataType.STUDY_SUBJECT_VISIT_OVER_TIME,
        field: 'StudySubjectVisitOverTime',
    },
    {
        areas: [AuditApplicationArea.ADMIN, AuditApplicationArea.CENTRAL_MONITORING],
        type: AuditDataType.STUDY_TREATMENT_ARM,
        field: 'StudyTreatmentArm',
    },
    {
        areas: [AuditApplicationArea.ADMIN],
        type: AuditDataType.SYSTEM_ORGANISATION,
        field: 'SystemOrganisation',
    },
    {
        areas: [AuditApplicationArea.ADMIN],
        type: AuditDataType.STUDY_ASSESSMENT,
        field: 'StudyAssessment',
    },
    {
        areas: [AuditApplicationArea.RISK_ASSESSMENT, AuditApplicationArea.ADMIN],
        type: AuditDataType.REPORT_DEFINITION,
        field: 'ReportDefinition',
    },
    {
        areas: [AuditApplicationArea.REPORT],
        type: AuditDataType.PBI_REPORT,
        field: 'PBIReport',
    },
    {
        areas: [AuditApplicationArea.ADMIN, AuditApplicationArea.CENTRAL_MONITORING],
        type: AuditDataType.STUDY_DASHBOARD_CONFIG,
        field: 'StudyDashboardConfig',
    },
    {
        areas: [AuditApplicationArea.ADMIN, AuditApplicationArea.CENTRAL_MONITORING],
        type: AuditDataType.STUDY_DASHBOARD_CONFIG_WIDGET,
        field: 'StudyDashboardConfigWidget',
    },
    {
        areas: [AuditApplicationArea.ADMIN, AuditApplicationArea.CENTRAL_MONITORING],
        type: AuditDataType.WIDGET,
        field: 'Widget',
    },
    {
        areas: [AuditApplicationArea.ADMIN, AuditApplicationArea.CENTRAL_MONITORING],
        type: AuditDataType.STUDY_DASHBOARD_CONFIG_PANEL,
        field: 'StudyDashboardConfigPanel',
    },
    {
        areas: [AuditApplicationArea.ADMIN, AuditApplicationArea.CENTRAL_MONITORING],
        type: AuditDataType.DATA_VIEW_FILTER,
        field: 'DataViewFilter',
    },
    {
        areas: [AuditApplicationArea.ADMIN, AuditApplicationArea.CENTRAL_MONITORING],
        type: AuditDataType.DATA_VIEW_CONFIGURATION,
        field: 'DataViewConfiguration',
    },
    {
        areas: [AuditApplicationArea.CENTRAL_MONITORING_2],
        type: AuditDataType.CM_2_REVIEW_LOG,
        field: 'CM2ReviewLog',
    },
    {
        areas: [AuditApplicationArea.CENTRAL_MONITORING_2],
        type: AuditDataType.PBICM_2_REPORT_SIGNATORY,
        field: 'PBICM2ReportSignatory',
    },
    {
        areas: [AuditApplicationArea.ADMIN, AuditApplicationArea.CENTRAL_MONITORING_2],
        type: AuditDataType.STUDY_HUB_SITE_FIELDS,
        field: 'StudyHubSiteFields',
    },
    {
        areas: [AuditApplicationArea.ADMIN, AuditApplicationArea.CENTRAL_MONITORING_2],
        type: AuditDataType.STUDY_HUB_STUDY_FIELDS,
        field: 'StudyHubStudyFields',
    },
    {
        areas: [AuditApplicationArea.CENTRAL_MONITORING_2],
        type: AuditDataType.DATASET_IMPORT_LOG,
        field: 'DatasetImportLog',
    },
    {
        areas: [AuditApplicationArea.DATA_QUALITY],
        type: AuditDataType.DATA_QUALITY_REPORT,
        field: 'DataQualityReport',
    },
    {
        areas: [AuditApplicationArea.ADMIN, AuditApplicationArea.CENTRAL_MONITORING_2],
        type: AuditDataType.CONTROLS_HUB_CONFIG_WIDGET,
        field: 'ControlsHubConfigWidget',
    },
    {
        areas: [AuditApplicationArea.ADMIN, AuditApplicationArea.CENTRAL_MONITORING_2],
        type: AuditDataType.CONTROLS_HUB_WIDGET,
        field: 'ControlsHubWidget',
    },
    {
        areas: [AuditApplicationArea.ADMIN, AuditApplicationArea.CENTRAL_MONITORING_2],
        type: AuditDataType.CONTROLS_HUB_CONFIG_PANEL,
        field: 'ControlsHubConfigPanel',
    },
    {
        areas: [
            AuditApplicationArea.OPRA,
            AuditApplicationArea.ADMIN,
            AuditApplicationArea.CENTRAL_MONITORING,
            AuditApplicationArea.RISK_ASSESSMENT,
            AuditApplicationArea.SUBJECT_MONITORING,
        ],
        type: AuditDataType.EXCEL_EXPORT,
        field: 'ExcelExport',
    },
    {
        areas: [AuditApplicationArea.SUBJECT_MONITORING],
        type: AuditDataType.SUBJECT_MONITORING_REVIEW,
        field: 'SubjectMonitoringReview',
    },
    {
        areas: [AuditApplicationArea.SUBJECT_MONITORING],
        type: AuditDataType.SUBJECT_DATA_LISTING_REVIEW,
        field: 'SubjectDataListingReview',
    },
    {
        areas: [AuditApplicationArea.SUBJECT_MONITORING],
        type: AuditDataType.SUBJECT_MONITORING_DATA_LISTINGS_CONFIG,
        field: 'SubjectMonitoringDataListingsConfig',
    },
    {
        areas: [AuditApplicationArea.SUBJECT_MONITORING],
        type: AuditDataType.SUBJECT_PROFILE_DETAILS_CONFIGURATION,
        field: 'SubjectProfileDetailsConfiguration',
    },
    {
        areas: [AuditApplicationArea.SUBJECT_MONITORING],
        type: AuditDataType.SUBJECT_MONITORING_SUBJECT_HUB_OVERVIEW_GRID_CONFIG,
        field: 'SubjectMonitoringSubjectHubOverviewGridConfig',
    },
    {
        areas: [AuditApplicationArea.SUBJECT_MONITORING],
        type: AuditDataType.SUBJECT_REVIEW_INSTANCE,
        field: 'SubjectReviewInstance',
    },
    {
        areas: [AuditApplicationArea.SUBJECT_MONITORING],
        type: AuditDataType.TAG_INSTANCE,
        field: 'TagInstance',
    },
    {
        areas: [AuditApplicationArea.SUBJECT_MONITORING],
        type: AuditDataType.TAG,
        field: 'Tag',
    },
    {
        areas: [AuditApplicationArea.SUBJECT_MONITORING],
        type: AuditDataType.SM_STUDY_MEMBER,
        field: 'SmStudyMember',
    },
    {
        areas: [AuditApplicationArea.SUBJECT_MONITORING],
        type: AuditDataType.PBISM_REPORT_SIGNATORY,
        field: 'SmReportSignatory',
    },
    {
        areas: [AuditApplicationArea.RISK_ASSESSMENT, AuditApplicationArea.ADMIN],
        type: AuditDataType.EXCEL_LISTING,
        field: 'ExcelListing',
    },
    {
        areas: [AuditApplicationArea.SUBJECT_MONITORING],
        type: AuditDataType.SUBJECT_OBSERVATIONS,
        field: 'SubjectObservations',
    },
    {
        areas: [AuditApplicationArea.SUBJECT_MONITORING],
        type: AuditDataType.SUBJECT_ACTIONS,
        field: 'SubjectActions',
    },

    {
        areas: [AuditApplicationArea.SUBJECT_MONITORING],
        type: AuditDataType.SUBJECT_REVIEW_LOGS,
        field: 'SubjectReviewLogs',
    },
    {
        areas: [AuditApplicationArea.ORGANISATION],
        type: AuditDataType.RISK_DASHBOARD_SETUP,
        field: 'RiskDashboardSetup',
    },
    {
        areas: [AuditApplicationArea.RISK_ASSESSMENT],
        type: AuditDataType.RISK_ASSESSMENT_TAG,
        field: 'RiskAssessmentTag',
    },
    {
        areas: [AuditApplicationArea.RISK_ASSESSMENT],
        type: AuditDataType.RISK_COMMENT,
        field: 'RiskComment',
    },
    {
        areas: [AuditApplicationArea.RISK_ASSESSMENT],
        type: AuditDataType.RISK_COMMENT_REPLY,
        field: 'RiskCommentReply',
    },
    {
        areas: [AuditApplicationArea.RISK_ASSESSMENT],
        type: AuditDataType.CTQ_COMMENT,
        field: 'CtqComment',
    },
    {
        areas: [AuditApplicationArea.RISK_ASSESSMENT],
        type: AuditDataType.CTQ_COMMENT_REPLY,
        field: 'CtqCommentReply',
    },
    {
        areas: [AuditApplicationArea.SUBJECT_MONITORING],
        type: AuditDataType.SUBJECT_MONITORING_REVIEW_TYPE,
        field: 'SubjectMonitoringReviewType',
    },
    {
        areas: [AuditApplicationArea.SUBJECT_MONITORING],
        type: AuditDataType.SUBJECT_MONITORING_REVIEW_PLAN,
        field: 'SubjectMonitoringReviewPlan',
    },
    {
        areas: [AuditApplicationArea.ORGANISATION],
        type: AuditDataType.CM_INTEGRATION_CONFIG,
        field: 'CMIntegrationConfig',
    },
];

export default TypeAreas;
